/* eslint-disable */
export function getDataVersion(context) {
  return localStorage.getItem('dataversion') || 'D-01';
}
